import { render } from "./ResponseActions.vue?vue&type=template&id=3fb7cbe8&ts=true"
import script from "./ResponseActions.vue?vue&type=script&lang=ts"
export * from "./ResponseActions.vue?vue&type=script&lang=ts"

import exportComponent from "D:\\a\\1\\s\\src\\app\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__